module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"siteTitle":"Devices"},"de":{"siteTitle":"Geräte"},"fr":{"siteTitle":"Appareils"},"it":{"siteTitle":"Dispositivi"}}')
  delete Component.options._Ctor
}
